var _rect, _rect2, _rect3, _rect4, _rect5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBarChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 76,
    viewBox: "0 0 171 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.7131,
    height: 76,
    fill: "#78A9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8326,
    y: 19,
    width: 17.7131,
    height: 57,
    fill: "#FF832B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.984,
    y: 11,
    width: 18.3944,
    height: 65,
    fill: "#8A3FFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 115.817,
    y: 31,
    width: 17.7131,
    height: 45,
    fill: "#A7F0BA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 153.287,
    y: 19,
    width: 17.7131,
    height: 57,
    fill: "#24A148"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgBarChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bar-chart.fe4fc4b807f969f0203ece4ee79ad34b.svg";